import { axiosInstance } from 'api/axios';

export const getFile = async (id: string) => {
  return await axiosInstance.get(`/file?id=${id}`);
};
